// Purpose: Compact vehicle summary card with optional drawer and details button.
// Audience: Users scanning results quickly.
// Features:
// - Shows make/model/color/confidence and associated plates
// - Optional thumbnails and marks in a drawer section
// - "Details" button to open VehicleDetailsPanel via parent callback
// Interplay: Used by JobInlineResults in results views
import React from 'react';

// Lightweight presentational component for a vehicle mini-card with optional drawer
// Expects vehicle object with fields: id, make, model, color, confidence, licensePlates[], marks[], media{bestImageUrl,bestPlateImageUrl}
// Optional platesForVehicle: fallback array of plates associated by parentVehicleId

const VehicleMiniCard = ({ vehicle, platesForVehicle = [], onOpenDetails }) => {
  const plateNumbers = (vehicle.licensePlates && vehicle.licensePlates.length > 0)
    ? vehicle.licensePlates.map(lp => lp.plateNumber)
    : (platesForVehicle || []).map(lp => lp.plateNumber);

  return (
    <div
      className="mini-card vehicle"
      onMouseDown={(e)=>e.stopPropagation()}
      onClick={(e)=>e.stopPropagation()}
    >
      <div className="mini-title">
        <span>Vehicle</span>
        <span className="mini-conf">{Math.round(((vehicle.confidence||0)*100))}%</span>
      </div>
      <div className="mini-body">
        <div className="mini-row"><span className="k">Make</span><span className="v">{vehicle.make || 'Unknown'}</span></div>
        <div className="mini-row"><span className="k">Model</span><span className="v">{vehicle.model || 'Unknown'}</span></div>
        <div className="mini-row"><span className="k">Color</span><span className="v">{vehicle.color || 'Unknown'}</span></div>
        {plateNumbers.length > 0 && (
          <div className="mini-row"><span className="k">Plates</span><span className="v">{plateNumbers.join(', ')}</span></div>
        )}
        <div className="vehicle-drawer">
          {(vehicle.media?.bestImageUrl || vehicle.media?.bestPlateImageUrl) && (
            <div className="vehicle-media">
              {vehicle.media?.bestImageUrl && <img src={vehicle.media.bestImageUrl} alt="vehicle" />}
              {vehicle.media?.bestPlateImageUrl && <img src={vehicle.media.bestPlateImageUrl} alt="plate" />}
            </div>
          )}
          {Array.isArray(vehicle.marks) && vehicle.marks.length > 0 && (
            <div className="marks-list">
              {vehicle.marks.slice(0,6).map(m => (
                <span key={m.id} className="mark-chip">{m.label}</span>
              ))}
            </div>
          )}
          {onOpenDetails && (
            <div style={{ marginTop: 8 }}>
              <button
                type="button"
                className="btn-secondary btn-sm"
                onMouseDown={(e)=>{ e.stopPropagation(); }}
                onClick={(e)=>{ e.stopPropagation(); e.preventDefault(); onOpenDetails(vehicle); }}
              >
                Details ▸
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(VehicleMiniCard);


